module.exports = __webpack_public_path__ + "static/family-3-7f8c0e66635916afbe9e52ce18d6fc64.jpg";